import { createRouter, createWebHistory } from 'vue-router';

import {
    ROUT_AUTH,
    ROUT_FOREIGN,
    ROUT_HOME,
    ROUT_TRASH,
    ROUT_USERS,
} from './constants';

const routes = [
    {
        path: ROUT_HOME,
        name: 'home',
        component: () => import('@/components/home/HomePage.vue')
    },
    {
        path: ROUT_AUTH,
        name: 'auth',
        component: () => import('@/components/auth/AuthPage.vue')
    },
    {
        path: ROUT_TRASH,
        name: 'trash',
        component: () => import('@/components/trash/TrashPage.vue')
    },
    {
        path: ROUT_USERS,
        name: 'users',
        component: () => import('@/components/users/UsersPage.vue')
    },
    {
        path: ROUT_FOREIGN,
        name: 'foreign',
        component: () => import('@/components/auth/ForeignPage.vue')
    },
    {
        path: '/500',
        name: '500',
        component: () => import('@/components/errors/ErrorPage500.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: () => import('@/components/errors/ErrorPage404.vue')
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes: routes
});

router.beforeEach( async (to, from, next) => {
    const freeAccess = [ROUT_AUTH].some(v => to.path.includes(v));
    if (!freeAccess && !localStorage.token) return next({path: ROUT_AUTH});
    if (freeAccess && localStorage.token) return next({path: ROUT_HOME});
    next();
});

export default router;